import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import Layout from '@/components/Layout';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import DayView from '@/pages/DayView';
import Customers from '@/pages/Customers';
import RoutesPage from '@/pages/Routes';
import Prices from '@/pages/Prices';
import Invoicing from '@/pages/Invoicing';
import Harvest from '@/pages/Harvest';
import Kylmio from '@/pages/Kylmio';
import Reports from '@/pages/Reports';
import Users from '@/pages/Users';
import '@/App.css';

function ProtectedRoutes() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F9F6]">
        <div className="text-[#6A6D66] text-sm">Ladataan…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <Layout />
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoutes />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/tilaukset" element={<DayView />} />
            <Route path="/asiakkaat" element={<Customers />} />
            <Route path="/reitit" element={<RoutesPage />} />
            <Route path="/hinnat" element={<Prices />} />
            <Route path="/laskutus" element={<Invoicing />} />
            <Route path="/poimintamaarat" element={<Harvest />} />
            <Route path="/kylmio" element={<Kylmio />} />
            <Route path="/raportit" element={<Reports />} />
            <Route path="/kayttajat" element={<Users />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}
